<template>
  <CCard class="dataTable">
    <CCardHeader v-if="totalRecords > 0 || tableFilterValue != ''" class="dataTable__header d-flex justify-content-between px-0">
      <div class="dataTable__countContants">
        <h2 class="font-weight-lighter font-5xl">
          {{ totalRecords || 0 }}<span class="font-xs text-uppercase ml-2">{{ $t('audience.audienceList.text.contacts') }}</span>
        </h2>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('audience.audienceList.input.search-placeholder')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
        >
        </CInput>
      </div>
      <div class="dataTable__buttonLink">
        <router-link class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" :to="{ name: 'choose-methods' }">{{
          $t('audience.audienceList.button.import-contacts')
        }}</router-link>
      </div>
    </CCardHeader>
    <div v-if="!loadingAudienceScore && totalRecords > 0" class="d-flex align-items-center gap-20 mb-2">
      <span class="font-weight-bold font-xl">{{ $t('audience.audienceList.score.text') }}</span>
      <StarRating v-if="starRatingValue" :score="starRatingValue" :starQuantity="starRatingQuantity" />
      <span v-else>-</span>
      <CButton class="px-0" v-c-tooltip="{ content: $t('audience.audienceList.score.tooltip'), placement: 'bottom' }">
        <CIcon name="question" size="custom-size" :height="25" viewBox="0 0 32 32" />
      </CButton>
    </div>

    <template>
      <div v-if="totalRecords > 0 || tableFilterValue != ''">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
        <HeaderActions
          :show="showHeaderActions"
          :totalRecords="totalRecords"
          :itemsListSelected="Boolean(itemsListSelected.length)"
          :typeName="$route.meta.name ? $t($route.meta.name) : 'Audience'"
          :tripleConfirmationText="$t('audience.audienceList.delete-all.confirmation-text')"
          @checkAll="checkAll"
          @confirm="deleteItemsSelected"
          @deleteAll="deleteAll"
          @exportRecods="exportAudience"
        />

        <CCardBody class="dataTable__body p-0">
          <CDataTable
            :items="registers"
            :fields="headers"
            :table-filter="{ external: true, lazy: true }"
            :table-filter-value.sync="tableFilterValue"
            items-per-page-select
            :items-per-page.sync="itemsPerPage"
            @pagination-change="paginationChange"
            :active-page="1"
            @row-clicked="rowClicked"
            hover
            :loading="loadingGetData"
          >
            <template #loading>
              <div class="d-flex justify-content-center align-items-center dataTable__loading">
                <CSpinner class="my-3" color="primary" />
              </div>
            </template>

            <template #_MetaData="{ item }">
              <OptInOut :opt="{ item }" :key="item.RecipientId" />
            </template>

            <template #_MetaData.Tags="{ item }">
              <Tags :opt="{ item }" />
            </template>

            <template #_MetaData.UpdatedDatetime="{ item }">
              <UpdatedDatetime :opt="{ item }" />
            </template>

            <template #select="{ item }">
              <td @click.stop="">
                <CInputCheckbox class="text-center checkboxTable" :checked="item._selected" @update:checked="() => check(item)" custom />
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </div>
    </template>

    <EmptyList
      :loading="loadingGetData"
      v-if="totalRecords == 0 && tableFilterValue == ''"
      :linkText="$t('audience.audienceList.button.import-contacts')"
      :linkTo="{ name: 'import-contacts' }"
      :title="$t('audience.audienceList.text.noAudience')"
      :subTitle="$t('audience.audienceList.text.importOrCreate')"
    />
    <div class="position-relative">
      <CPagination
        v-show="pages > 0 && totalRecords > 0"
        align="center"
        :pages="pages"
        :active-page.sync="activePage"
        class="dataTable__newPagination mt-3"
      >
        <template slot="previous-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.prev') }}
          </span>
        </template>
        <template slot="next-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.next') }}
          </span>
        </template>
      </CPagination>
      <CElementCover v-if="loadingGetData" :opacity="0.8" style="z-index: 1001">
        <div></div>
      </CElementCover>
    </div>

    <!--<CPagination
      v-show="pages > 0 && totalRecords > 0"
      :pages="pages"
      class="dataTable__pagination"
      :class="{ [$style.blockClick]: this.loadingGetData }"
      :doubleArrows="false"
      :active-page.sync="activePage"
      ref="pagination"
    >
      <template slot="previous-button">
        <span class="pagination__button p-2">
          <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
        </span>
      </template>

      <template slot="next-button">
        <span class="pagination__button p-2">
          <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
        </span>
      </template>
    </CPagination>

    

    <div v-if="pagination.totalPages >= 1" class="page-item d-flex justify-content-center paginationDetail text-gray-600">
      {{ pagination.currentPage + 1 }} {{ $t('general.components.pagination.of') }} {{ pagination.totalPages }}
    </div>-->
  </CCard>
</template>

<script>
const columnSelect = {
  key: 'select',
  label: '',
  _classes: 'hidde',
  _style: 'width:40px',
}

const columnAplication = [
  { key: '_MetaData', label: 'opt in  & opt out' },
  { key: '_MetaData.Tags', label: 'Tags' },
  {
    key: '_MetaData.UpdatedDatetime',
    label: 'LAST CHANGE',
    _style: 'min-width:200px',
  },
  // {'key': 'Contanct Rating', 'label': 'Contanct Rating'},
]

// import CheckItem from "@/components/table/CheckItem";
import OptInOut from '@/components/table/OptInOut'
import Tags from '@/components/table/Tags'
import UpdatedDatetime from '@/components/table/UpdatedDatetime'
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'
import EmptyList from '@/components/EmptyList'
import StarRating from '../../../components/StarRating.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AudienceList',
  components: {
    // CheckItem,
    OptInOut,
    UpdatedDatetime,
    Tags,
    MenssageAlert,
    HeaderActions,
    EmptyList,
    StarRating,
  },
  data() {
    return {
      sorterValue: { column: null, asc: true },
      columnFilterValue: {},
      tableFilterValue: '',
      loadedItems: [],
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalRecords: 0,
      itemsListSelected: [],
      activePage: 0,
      responsive: false,
      messages: [],
      loadingGetData: false,
      pagination: [],
      starRatingValue: undefined,
      starRatingQuantity: 5,
    }
  },

  created() {
    this.loadingGetData = true
    this.getHeaders(this.organizationId, this.tableFilterValue, this.pages, this.itemsPerPage)
    this.getAudienceScore()
  },

  watch: {
    reloadParams: {
      handler(newValue, oldValue) {
        // TODO precisei fazer isso para impedir 2 requisições ao entrar na pagina.
        // caso entre mais props no getdata() terá que mudar o indice do array newValue[3], oldValue[3]

        // newValue[3] pagina atual -  oldValue[3] pagina antiga
        if (newValue[3] == 1 && oldValue[3] == 0) return
        this.onTableChange()
      },
    },

    totalRecords(newValue) {
      if (newValue > 1580 || this.totalRecords > 1580) {
        this.typeFileExport = 'csv'
      }
    },
  },

  computed: {
    ...mapGetters({
      isOrganizationBase: 'auth/isOrganizationBase',
    }),

    isCurrentOrganizationBase() {
      return this.isOrganizationBase(this.$route.params.organizationId)
    },

    showHeaderActions() {
      return { checkItems: true, manage: true, delete: this.isCurrentOrganizationBase, deleteAll: this.isCurrentOrganizationBase, export: this.isCurrentOrganizationBase }
    },

    registers() {
      return this.loadedItems.map((user) => {
        return {
          ...user,
          _selected: this.itemsListSelected.includes(user.RecipientId),
          _classes: [user._classes, user._selected || this.itemsListSelected.includes(user.RecipientId) ? 'table-selected' : ''],
        }
      })
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    reloadParams() {
      return [this.sorterValue, this.columnFilterValue, this.tableFilterValue, this.activePage, this.itemsPerPage]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage + 1
      return `${first} - ${this.activePage * 10}  of ${this.totalRecords}`
    },

    organizationId() {
      return this.$route.params.organizationId
    },

    validateExport() {
      if (this.typeFileExport == 'xls') {
        return false
      }

      if (this.typeFileExport == 'csv' && this.cvsCharacters !== null) {
        return false
      }

      return true
    },
  },

  methods: {
    setStarRatingScore(audienceScore) {
      const proportionalStarValue = audienceScore / this.starRatingQuantity

      this.starRatingValue = proportionalStarValue
    },
    async getAudienceScore() {
      try {
        this.loadingAudienceScore = true
        const response = await services.getAudienceScore(this.organizationId)
        const audienceScore = response.data.data.audienceScoreValue

        this.setStarRatingScore(audienceScore)
      } finally {
        this.loadingAudienceScore = false
      }
    },
    headerHandle(arr) {
      let headers = arr.reduce((acc, cur) => {
        const isKey = cur.isKey ? 'KeyColumn' : ''
        acc.push({
          key: cur.fieldName,
          label: cur.value,
          isKey: cur.isKey,
          _classes: isKey,
          _style: cur.value == 'SMS' ? 'min-width:180px' : '',
        })
        return acc
      }, [])

      return [columnSelect, ...headers, ...columnAplication]
    },

    mountedItemAudience(arr) {
      return new Promise((resolve) => {
        let keys = []
        let lastIndex = null

        for (let g = 0; g < this.headers.length; g++) {
          keys.push(this.headers[g].key)
        }

        for (let i = 0; i < keys.length; i++) {
          if (keys.includes('Field' + i)) {
            lastIndex = i
          }
        }

        for (let j = 0; j < arr.length; j++) {
          for (let m = 0; m < lastIndex; m++) {
            let fieldValue = m + 1
            let fieldName = 'Field' + fieldValue
            if (!arr[j].data.hasOwnProperty(fieldName)) {
              arr[j].data[fieldName] = ''
            }
          }
        }

        // alterado para qnd o valor da celula vier null mudar para vazio
        arr.forEach((element) => {
          Object.keys(element.data).forEach((item) => {
            element.data[item] = element.data[item] == null ? '' : element.data[item]
          })
        })

        const result = arr.reduce((acc, cur, index) => {
          acc.push({
            ...cur.data,
            index: index,
            _classes: [cur._classes, cur._selected ? 'table-selected' : ''],
          })
          return acc
        }, [])

        resolve(result)
      })
    },

    async getHeaders(organizationId, term, Page, Count) {
      this.loadingGetData = true
      this.messages = []

      if (!this.$store.state.audience.hasAudience) {
        await this.$store.dispatch('audience/hasAudience', this.$route.params.organizationId)
      }

      services
        .audienceSchema(organizationId)
        .then(async (schema) => {
          this.headers = this.headerHandle(schema.data.data.values)
          await this.getData(organizationId, term, Page, Count)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.loadingGetData = false
        })
    },

    async getData(organizationId, term, Page, Count) {
      return new Promise((resolve) => {
        this.messages = []
        this.loadingGetData = true
        services
          .audience(organizationId, term, Page, Count)
          .then(async (audience) => {
            this.pages = audience.data.data.pagination.totalPages
            this.totalRecords = audience.data.data.pagination.totalRecords
            this.activePage = audience.data.data.pagination.currentPage + 1
            this.pagination = audience.data.data.pagination
            this.loadedItems = await this.mountedItemAudience(audience.data.data.recipients)
            if (this.totalRecords > 0) await this.getAudienceScore()
          })
          .catch(() => {
            this.loadedItems = []
          })
          .finally(() => {
            this.loadingGetData = false
            resolve()
          })
      })
    },

    onTableChange() {
      this.loadingGetData = true
      this.getData(this.organizationId, this.tableFilterValue, this.activePage - 1, this.itemsPerPage)
    },

    rowClicked(item, index, column, e) {
      if (!['INPUT', 'LABEL'].includes(e.target.tagName)) {
        this.goToDatail(item)
      }
    },

    goToDatail(recipient) {
      this.$router.push({
        name: 'contact-detail',
        params: { id: recipient.RecipientId },
      })
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    checkedItem(id = '') {
      if (this.itemsListSelected.includes(id)) {
        this.itemsListSelected = this.itemsListSelected.filter((item) => item !== id)
        return
      }

      this.itemsListSelected.push(id)
    },

    checkedAllitems(state) {
      if (!state) {
        this.itemsListSelected = []
        return
      }

      this.itemsListSelected = this.loadedItems.reduce((acc, cur) => {
        acc.push(cur.RecipientId)
        return acc
      }, [])
    },

    check(item) {
      const val = Boolean(this.loadedItems[item.index]._selected)
      this.$set(this.loadedItems[item.index], '_selected', !val)
      this.checkedItem(item.RecipientId)
    },

    checkAll(state) {
      this.loadedItems.map((item) => {
        this.$set(this.loadedItems[item.index], '_selected', state)
      })

      this.checkedAllitems(state)
    },

    deleteAll() {
      this.messages = []
      services
        .audienceDelete(this.organizationId)
        .then(() => {
          this.loadedItems = []
          this.totalRecords = []
          this.tableFilterValue = ''
          this.pages = 0
          this.itemsPerPage = 10
          this.getHeaders(this.organizationId, this.tableFilterValue, this.pages, this.itemsPerPage)
          this.pagination.totalPages = 0
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    deleteItemsSelected() {
      this.messages = []

      const formatQuery = this.itemsListSelected
        .map((item) => {
          return `id=${item}`
        })
        .join('&')

      services
        .audienceDelete(this.organizationId, formatQuery)
        .then(({ data }) => {
          this.onTableChange()
          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })

          setTimeout(() => {
            this.itemsListSelected = []
          }, 1000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    exportAudience(body) {
      this.messages = []
      const audienceRecipients = this.itemsListSelected.length ? this.itemsListSelected : null

      services
        .exportAudience(this.organizationId, { ...body, audienceRecipients })
        .then(() => {
          this.statePopUpManage = false

          this.$store.commit('setToastMessage', {
            title: 'EXPORT OF AUDIENCE',
            text: 'Your request is being processed',
          })

          // setTimeout(() => {
          //   this.getParamsDownload(data.data.fileName);
          // }, 20000);
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.gap-20 {
  gap: 20px;
}
</style>
<style module>
.blockClick {
  pointer-events: none;
}
</style>
